import { useInstance } from 'common-module/src/util/useInstance';

export const useVuex = () => {
  const vm = useInstance();
  if (!vm.$store) {
    Object.defineProperty(vm, '$store', {
      get: function get() {
        return this._store;
      }
    });
  }
  return vm.$store;
};

export const useGetter = (name: string) => {
  const vuex = useVuex();
  return vuex.getters[name];
};
